import api from './api';

/**
 * Envia os anexos depois que a manifestação já existe, autenticando por
 * protocolo+PIN. Vai separado do JSON porque arquivo não trafega em JSON.
 */
export async function enviarEvidencias(protocolo, pin, arquivos) {
  if (!arquivos || arquivos.length === 0) return;

  const dados = new FormData();
  dados.append('pin', pin);
  arquivos.forEach((arquivo) => dados.append('arquivos', arquivo));

  await api.post(`/public/manifestacoes/${protocolo}/evidencias`, dados, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
}
